/*
 * Copyright (C) 2020 Graylog, Inc.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the Server Side Public License, version 1,
 * as published by MongoDB, Inc.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * Server Side Public License for more details.
 *
 * You should have received a copy of the Server Side Public License
 * along with this program. If not, see
 * <http://www.mongodb.com/licensing/server-side-public-license>.
 */
import CombinedProvider from 'injection/CombinedProvider';

class StoreProvider {
  getStore(storeName) {
    const result = CombinedProvider.get(storeName);

    if (!result[`${storeName}Store`]) {
      throw new Error(`Requested store "${storeName}" is not registered.`);
    }

    return result[`${storeName}Store`];
  }
}

if (typeof window.storeProvider === 'undefined') {
  window.storeProvider = new StoreProvider();
}

export default window.storeProvider;
